module.exports = __webpack_public_path__ + "static/media/Policies_RCP.b3c7c38e.pdf";